// Update log
// FB  6192   02/06/2023  DK  Added for global parameters used all over the site

const Configurations = {
  API: "https://mdchartsportal.com:42103",
  //API: "https://mraemrtest.com:60503",
  clientIp: "",
  digitalApptType: "TeleHealth",
  twilio: {
    accountSid: "ACc51af6a1da8cf52e6b9fdd6fa5cefbd1",
    apiKey: "SKf8187909d6235c1f065bd25598a08821",
    apiSecret: "QPP8o7vN5su3mNjbaYroaIX3l8dfp9bW",
  },
};

export default Configurations;
